import { Injectable, inject } from '@angular/core';
import { HttpCoreService } from '@dataclouder/ngx-core';

import { GenerateImageRequest, GenerateVideoDto } from './models/video-generation.model';
import { GenerateImageAdapterResponse } from './models/image-gen.models';
import { GeneratedAsset } from './components/generated-assets-history/generated-assets-history.component';

export enum ChatRoleVertex {
  System = 'system',
  User = 'user',
  Assistant = 'assistant',
}

export class ChatMessage {
  role: ChatRoleVertex;
  content: string;
}

const ENDPOINTS = {
  image: 'api/vertex-adapter/image',
  tts: 'api/vertex-adapter/tts',
  video: 'api/vertex-adapter/video',
  llm: 'api/vertex-adapter/llm',
};

@Injectable({
  providedIn: 'root',
})
export class NgxVertexService {
  private httpCore = inject(HttpCoreService);

  constructor() {}

  // Example method - replace with actual API calls
  // TODO: remove this method after refactoring
  async callVertexApi<T = any>(endpoint: string, method: 'GET' | 'POST' | 'PUT' | 'DELETE', data?: any): Promise<T> {
    const servicePath = `${ENDPOINTS[endpoint]}`;
    switch (method) {
      case 'GET':
        return this.httpCore.get<T>(servicePath);
      case 'POST':
        return this.httpCore.post<T>(servicePath, data);
      case 'PUT':
        return this.httpCore.put<T>(servicePath, data);
      case 'DELETE':
        return this.httpCore.delete<T>(servicePath);
      default:
        throw new Error(`Unsupported HTTP method: ${method}`);
    }
  }

  async generateImage(request: GenerateImageRequest, local: boolean = false): Promise<any> {
    // Assuming 'generate-image' is the correct endpoint suffix

    // const endpoint = local ? 'generate-image?provider=local' : 'generate-image';

    const data = await this.httpCore.post<GenerateImageAdapterResponse>(`${ENDPOINTS.image}/generate-image`, request);
    return data;
  }

  async generateText(request: ChatMessage[]): Promise<any> {
    // Assuming 'generate-text' is the correct endpoint suffix
    return this.httpCore.post<GenerateImageAdapterResponse>(`${ENDPOINTS.image}/generate-text`, request);
  }

  async listImageModels(local: boolean = false): Promise<any> {
    // const endpoint = local ? 'list-models?provider=local' : 'list-models';
    const endpoint = 'list-models';
    const models = await this.httpCore.get(`${ENDPOINTS.image}/${endpoint}`);
    return models;
  }

  async generateVideo(request: GenerateVideoDto, local: boolean = false): Promise<GeneratedAsset> {
    if (local) {
      const data = await this.httpCore.post<GeneratedAsset>(`${ENDPOINTS.video}/generate-video?provider=local`, request);
      return data;
    }

    const data = await this.httpCore.post<GeneratedAsset>(`${ENDPOINTS.video}/generate-veo-video`, request);
    return data;
  }

  async getStatusFor(operationId: string): Promise<GeneratedAsset> {
    const data = await this.httpCore.post<GeneratedAsset>(`${ENDPOINTS.video}/veo-video-status`, { operationName: operationId });
    return data;
  }

  async listVideoModels(local: boolean = false): Promise<any> {
    // For now, returning a hardcoded list as the actual endpoint might not exist yet.
    return Promise.resolve([{ name: 'Veo 1.0', id: 'veo-1.0' }]);
  }
}
